import React from "react";
import { useNavigate } from "react-router-dom";
import { Brand, Eyebrow } from "@/components/brand";

export default function TermsOfService() {
  const navigate = useNavigate();
  const sections = [
    { title: "1. Acceptance of Terms", content: "By accessing and using Equal AI, you accept and agree to be bound by these Terms of Service. If you do not agree, please do not use the service." },
    { title: "2. Service Description", content: "Equal AI provides AI-powered advisory services for cannabis equity applicants in the City of Long Beach, including an AI consultant chat interface, access to curated knowledge base content, session transcripts, and direct access to human support when needed." },
    { title: "3. Transparency & Data Sharing", content: "By using Equal AI, you acknowledge and consent that your session data, including conversation transcripts, will be automatically shared with City of Long Beach officials for transparency, compliance, and program oversight.", highlight: true },
    { title: "4. User Responsibilities", content: "You agree to provide accurate and truthful information, use the Service only for lawful purposes related to cannabis equity applications, maintain the confidentiality of your account credentials, and not attempt to circumvent security measures." },
    { title: "5. Limitation of Liability", content: "Equal AI and its operators shall not be liable for any direct, indirect, incidental, or consequential damages arising from your use of the Service. You use the Service at your own risk." },
    { title: "6. Contact", content: "For questions: yan@tkachventures.com · Equal AI - Cannabis Equity Advisory Platform" },
  ];

  return (
    <div className="min-h-screen bg-page">
      <header className="h-14 bg-white border-b border-line px-5 md:px-8 flex items-center">
        <Brand onClick={() => navigate("/")} />
      </header>
      <div className="bg-mint border-b border-[#cfe9db]">
        <div className="max-w-3xl mx-auto px-5 md:px-8 py-14">
          <Eyebrow className="text-equal-dark mb-3">Legal</Eyebrow>
          <h1 className="text-4xl sm:text-5xl font-extrabold text-ink tracking-tight leading-[1.05] mb-3">Terms of Service</h1>
          <p className="text-mute text-sm font-mono">Last Updated: April 29, 2026</p>
        </div>
      </div>
      <div className="max-w-3xl mx-auto px-5 md:px-8 py-12">
        <div className="card-flat p-7 md:p-10 space-y-9 text-ink-2 text-sm leading-relaxed">
          <div className="p-4 rounded-[10px] bg-[#fdecea] border border-[#f2c1bb]">
            <p className="th-mono text-[#c0392b] mb-1">Important Disclaimer</p>
            <p className="text-[#8a2a1f] text-xs leading-relaxed">Equal AI provides informational guidance only. This is NOT legal advice. Always consult qualified legal and business professionals for official advice.</p>
          </div>
          {sections.map((s, i) => (
            <div key={s.title} className="grid sm:grid-cols-[40px_1fr] gap-3">
              <span className="font-mono text-[11px] text-mute pt-1">{String(i + 1).padStart(2, "0")}</span>
              <div>
                <h2 className="text-ink font-bold text-base tracking-tight mb-2">{s.title}</h2>
                {s.highlight && (
                  <div className="mb-3 p-3 rounded-[10px] bg-cream border border-[#e6dfd0] text-ink-2 text-xs">
                    Mandatory: Sessions are shared with City of Long Beach officials as part of program oversight.
                  </div>
                )}
                <p>{s.content}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
